import * as Immutable from 'immutable';
import {licenses} from '../constants/licenses';
import * as constants from '../constants/system-setup-constants';

/*
 * to generate a new license file:
 * run 'npm run get-licenses' for each package file.
 * concatenate all raw license files into a JSON array of license files
 * import JSON file here as 'rawLicenses'
 * import {getLibrariesFromRawJsonList} from '../helpers/library-helpers'
 * const licenses = getLibrariesFromRawJsonList(rawLicenses)
 */

import {createReducer} from 'redux-store';

import type {List} from 'immutable';

export type SSLibrariesStore = {
    libraries: List<unknown>;
};

const initialState = () => {
    return {
        libraries: Immutable.List(),
    };
};

const actionsMap = {
    [constants.SS_LIBRARIES_SUCCESS]: () => {
        return {
            libraries: licenses,
        };
    },

    [constants.DISPOSE_SS_LIBRARIES_STORE]: () => {
        return initialState();
    },
};

export default createReducer<SSLibrariesStore>(initialState(), actionsMap);
